
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import AppStoreButton from "../../../common/AppStoreButton";
import PlayMarketButton from "../../../common/PlayMarketButton";
import DappStoreButton from "../../../common/DappStoreButton";
const Banner = ({ banner, icon, isDapp, dappUrl }) => {
    return (<section className={'banner'}>
            <div className="container">
                <div className="banner_wrapper">
                    <h1 className={'banner_title'}>
                        <span>{banner.title_1}
                            <picture>
                            {/*<source*/}
                                {/*    media="(max-width: 768px)"*/}
                                {/*    srcSet={`/img/pages/home/banner/banner_${slide.img}_small.webp`}*/}
                                {/*    type="image/webp"*/}
                                {/*/>*/}
                                {/*<source*/}
                                {/*    media="(min-width: 769px)"*/}
                                {/*    srcSet={`/img/pages/home/banner/banner_${slide.img}.webp`}*/}
                                {/*    type="image/webp"*/}
                                {/*/>*/}
                                {/*<source*/}
                                {/*    media="(max-width: 768px)"*/}
                                {/*    srcSet={`/img/pages/home/banner/banner_${slide.img}_small.png`}*/}
                                {/*/>*/}
                                {/*<source*/}
                                {/*    media="(min-width: 769px)"*/}
                                {/*    srcSet={`/img/pages/home/banner/banner_${slide.img}.png`}*/}
                                {/*/>*/}
                                <img src={`/img/pages/ecosystem/banner/${icon}.png`} alt={`ColdWare Wallet`} width={380} height={380} className='banner_title_icon'/>
                        </picture>
                        </span>
                        <span>{banner.title_2}</span>


                    </h1>
                    <div className={'banner_app'}>
                        <h2 className={'banner_app_title'}>
                            {banner.app_title}
                        </h2>
                        {isDapp ? <div className={'banner_app_cta'}>
                            <a href={dappUrl} className={'banner_app_cta_item app_store'}>
                                <DappStoreButton />
                            </a></div> : <div className={'banner_app_cta'}>
                            <a href={'#'} className={'banner_app_cta_item app_store'}>
                                <AppStoreButton />
                            </a>
                            <a href={'#'} className={'banner_app_cta_item play_market'}>
                                <PlayMarketButton />
                            </a>
                        </div>}
                    </div>
                </div>
            </div>
        </section>);
};
export default Banner;

    async function __Next_Translate__getStaticProps__1976335832b__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//ecosystem/Banner/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1976335832b__ as getStaticProps }
  